
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 30 30","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 0c8.286 0 15 6.714 15 15s-6.714 15-15 15S0 23.286 0 15 6.714 0 15 0zm-1.748 8.685l4.566 4.38H6.774c-.804 0-1.451.647-1.451 1.451v.968c0 .804.647 1.452 1.451 1.452h11.044l-4.566 4.378a1.453 1.453 0 00-.024 2.075l.665.66a1.446 1.446 0 002.05 0l8.027-8.02a1.446 1.446 0 000-2.051l-8.026-8.032a1.446 1.446 0 00-2.05 0l-.666.659a1.46 1.46 0 00.024 2.08z"}})])
          )
        }
      }
    